import React, { FC, ReactNode, useEffect, useState } from "react";

import { useCurrentViewPort, ViewPort } from "@gamedev-web/gamedev-sdk-core";

import * as styles from "../RightSideWrapper/RightSideWrapper.module.css";

type RightSideWrapperProps = {
  rightSideComponent: JSX.Element;
  style?: React.CSSProperties;
  wrapperStyle?: React.CSSProperties;
  children: ReactNode;
};

export const RightSideWrapper: FC<RightSideWrapperProps> = ({
  rightSideComponent,
  style,
  wrapperStyle,
  children,
}) => {
  const [isReady, setIsReady] = useState(false);
  const currentViewPort = useCurrentViewPort();
  useEffect(() => {
    // Because of the special styling applied here (with absolute position) and the amount of hooks we got to load our pages,
    // it is necessarily for server-side rendering to wait until the components are loaded to show the right side component.
    // Not doing this causes some breaking styling on the children components here.
    setIsReady(true);
  }, []);

  if (!isReady) {
    return <>{children}</>;
  }

  return (
    <div className={styles.wrapper} style={wrapperStyle}>
      {currentViewPort < ViewPort.LG && rightSideComponent}
      {children}
      {currentViewPort >= ViewPort.LG && (
        <div className={styles.absoluteContainer} style={style}>
          {rightSideComponent}
        </div>
      )}
    </div>
  );
};
